import React, {useState, useEffect} from "react";
import Header from "../Components/Header";
import { useNavigate } from "react-router-dom";
import Pagination from '@mui/material/Pagination';
import axios from "axios";
import { ReactSession } from 'react-client-session';
ReactSession.setStoreType("localStorage");



const Editsliders = () => {
   const userId=ReactSession.get("welbeingId");
  const queryParameters = new URLSearchParams(window.location.search)
  const sliderId = queryParameters.get("id");
  const navigate = useNavigate();
  const[formdata, setfromdata]= useState("");
  const[banner, setbanner]= useState({});
  const [error, setError] = useState("");
  const [file, setFile] = useState(""); 
  const [file2, setFile2] = useState(""); 

  console.log(formdata);
  if(userId  <= 0 ){
      navigate('/login');
   }



    const handlechange =(e)=>{
        const name=e.target.name;
        const value=e.target.value;
        setfromdata(values=> ({...values, [name]:value}))

    }

     const handleFile = (event) => {
        setFile(event.target.files[0]); // Only taking the first file if multiple files are selected
    };


     const handleFile2 = (event) => {
        setFile2(event.target.files[0]); // Only taking the first file if multiple files are selected
    };


    const handlesubmit = async(e) =>{
        e.preventDefault();


        const formData = new FormData();
        formData.append('text1', formdata.text1);
        formData.append('text2', formdata.text2);
        formData.append('text3', formdata.text3);
        formData.append('text4', formdata.text4);
        formData.append('text5', formdata.text5);
        formData.append('text6', formdata.text6);
        formData.append('des', formdata.description);
        formData.append('image1', file);
        formData.append('image2', file2);
        console.log(formdata);

        try{
          const response = await axios.post('https://api.welbeing.in/admin/banner/edit-banner/', formData);
            console.log(response.data);
          if(response.data.status === "success"){
            navigate("/sliders");
          }else{
            console.log(response.error);
          }
        }catch (err) {
             setError(err.message);
                
        }
    };



     
        const Sliders = async() =>{
            try{
                const response = await axios.get('https://api.welbeing.in/admin/banner/get-banner/');
                console.log(response.data);
                if(response.data.status==="success"){
                    const filteredData = response.data.data.filter(item => item.id === sliderId);
                    console.log(filteredData);
                
                setfromdata(filteredData[0]);
                setFile(filteredData[0].image1);
                setFile2(filteredData[0].image2);
                }else{
                   console.error(response.data.error?.message);
                }
            }catch (err) {
                 setError(err.message);
                    
            }
        };

        useEffect(() => {
           Sliders();
        }, []);







       

    return(

             <>
       
        <Header/>
        <div class="page-wrapper" id="main-wrapper" data-layout="vertical" data-sidebartype="full" data-sidebar-position="fixed" data-header-position="fixed">
        
        
           <div class="body-wrapper">
            
        
             <div class="container-fluid">
       
        <div class="card bg-light-info shadow-none position-relative overflow-hidden">
            <div class="card-body px-4 py-3">
              <div class="row align-items-center">
                <div class="col-9">
                  <h4 class="fw-semibold mb-8">Edit sliders</h4>
                  <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                      <li class="breadcrumb-item"><a class="text-muted" href="dashboard.php">Dashboard</a></li>
                      <li class="breadcrumb-item" aria-current="page">Edit sliders</li>
                    </ol>
                  </nav>
                </div>
                <div class="col-3">
                  <div class="text-center mb-n5">  
                    <img src="dist/images/breadcrumb/ChatBc.png" alt="" class="img-fluid mb-n4"/>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content Section  */}
        <section>
           
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-body">
                    <div class="mb-2">
                      <h5 class="mb-0"></h5>
                    </div>
                    <div class="table-responsive">
                      <section>
                        <div class="row">
                           <div class="col-lg-12">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="table-responsive">
                                            <form onSubmit={handlesubmit}>
                                               <div class="form-body">
                                                  <div class="row">
                                                     <div class="col-md-4">
                                                       <div class="mb-3">
                                                          <label>Text 1</label>
                                                          <input type="text" class="form-control" name="text1" placeholder="Enter the Text..." value={formdata.text1} onChange={handlechange}/>
                                                       </div>
                                                     </div> 
                                                     <div class="col-md-4">
                                                       <div class="mb-3">
                                                          <label>Test 2</label>
                                                          <input type="text" class="form-control" name="text2" placeholder="Enter the Text..." value={formdata.text2} onChange={handlechange}/>
                                                       </div>
                                                     </div> 
                                                     <div class="col-md-4">
                                                       <div class="mb-3">
                                                          <label>Test 3</label>
                                                          <input type="text" class="form-control" name="text3" placeholder="Enter the Text..." value={formdata.text3} onChange={handlechange}/>
                                                       </div>
                                                     </div>
                                                     <div class="col-md-4">
                                                       <div class="mb-3">
                                                          <label>Text 4</label>
                                                          <input type="text" class="form-control" name="text4" placeholder="Enter the Text..." value={formdata.text4} onChange={handlechange}/>
                                                       </div>
                                                     </div>  													 
                                                  
                                                     <div class="col-md-4">
                                                       <div class="mb-3">
                                                          <label>Text 5</label>
                                                          <input type="text" class="form-control" name="text5" placeholder="Enter the Text..." value={formdata.text5} onChange={handlechange}/>
                                                       </div>
                                                     </div> 
                                                     <div class="col-md-4">
                                                       <div class="mb-3">
                                                          <label>Text 6</label>
                                                          <input type="text" class="form-control" name="text6" placeholder="Enter the Text..." value={formdata.text6} onChange={handlechange}/>
                                                       </div>
                                                     </div> 	

                                                     <div class="col-md-12">
                                                       <div class="mb-3">
                                                          <label>Description</label>
                                                          <textarea type="text" rows={3} class="form-control" name="description" placeholder="Enter the Text..." value={formdata.description} onChange={handlechange}/>
                                                       </div>
                                                     </div> 	


                                                      <div className="row">
                                                               {/* Image 1 */}
                                                                <div className="col-md-6">
                                                                  <div className="mb-3">
                                                                    <label>Image 1</label>
                                                                    <input 
                                                                      type="file" 
                                                                      className="form-control d-none" 
                                                                      id="image1" 
                                                                      accept="image/*" 
                                                                      onChange={(e) => handleFile(e, 'image1')}
                                                                    />
                                                                    
                                                                    {file ? (
                                                                      <div className="image-preview-container mt-2">
                                                                        <img 
                                                                         
                                                                           src={`http://localhost/projects/welbeing-admin-api/product_data/${file}`}
                                                                          alt="Preview 1" 
                                                                          className="img-thumbnail mb-2" 
                                                                          style={{ maxHeight: '200px' }}
                                                                        />
                                                                        <div>
                                                            {/* Edit button that triggers the file input */}
                                                            <label
                                                              htmlFor="imageInput"  // This associates the label with the input
                                                              className="btn btn-success w-50 d-flex justify-content-center align-items-center"
                                                              style={{ height: '40px', cursor: 'pointer' }}
                                                            >
                                                              Edit
                                                            </label>
                                                          
                                                            {/* Hidden file input */}
                                                            <input
                                                              type="file"
                                                              id="imageInput"  // This matches the label's htmlFor
                                                              accept="image/*"
                                                              style={{ display: 'none' }}
                                                              onChange={handleFile}
                                                            />
                                                          </div>
                                                                      </div>
                                                                    ) : (
                                                                     <div className="mb-3">
                                                                    <label>Image 1</label>
                                                                    <input 
                                                                      type="file" 
                                                                      className="form-control d-none" 
                                                                      id="image1" 
                                                                      accept="image/*" 
                                                                      onChange={(e) => handleFile(e, 'image1')}
                                                                    />
                                                                    </div>
                                                                    )}
                                                                  </div>
                                                                </div>
                                                          
                                                                {/* Image 2 */}
                                                                <div className="col-md-6">
                                                                  <div className="mb-3">
                                                                    <label>Image 2</label>
                                                                    <input 
                                                                      type="file" 
                                                                      className="form-control d-none" 
                                                                      id="image2" 
                                                                      accept="image/*" 
                                                                      onChange={handleFile2}
                                                                    />
                                                                    
                                                                    {file2 ? (
                                                                      <div className="image-preview-container mt-2">
                                                                        <img 
                                                                          src={`http://localhost/projects/welbeing-admin-api/product_data/${file2}`}
                                                                          alt="Preview 2" 
                                                                          className="img-thumbnail mb-2" 
                                                                          style={{ maxHeight: '200px' }}
                                                                        />
                                                                         <div>
                                                            {/* Edit button that triggers the file input */}
                                                            <label
                                                              htmlFor="imageInput"  // This associates the label with the input
                                                              className="btn btn-success w-50 d-flex justify-content-center align-items-center"
                                                              style={{ height: '40px', cursor: 'pointer' }}
                                                            >
                                                              Edit
                                                            </label>
                                                          
                                                            {/* Hidden file input */}
                                                            <input
                                                              type="file"
                                                              id="imageInput"  // This matches the label's htmlFor
                                                              accept="image/*"
                                                              style={{ display: 'none' }}
                                                              onChange={handleFile2}
                                                            />
                                                          </div>
                                                          </div>
                                                             ) : (
                                                               <div className="mb-3">
                                                             <label>Image 2</label>
                                                             <input 
                                                               type="file" 
                                                               className="form-control d-none" 
                                                               id="image1" 
                                                               accept="image/*" 
                                                               onChange={(e) => handleFile(e, 'image1')}
                                                             />
                                                             </div>
                                                             )}
                                                           </div>
                                                         </div>
                                                       </div>											 
                                                  </div>    												  
                                               </div> 
                                               <div class="form-actions">
                                                  <div class="text-start">
                                                     <button type="submit" class="btn btn-light-primary text-primary font-medium"> Edit </button>
                                                  </div>
                                               </div>
                                            </form>   
                                        </div>
                                    </div>
                                </div>
                            </div>
                         
                        </div>  
              </section></div>
            </div>
              </div>
            </div>
          </div></section>
             </div>
            </div>
        </div>
        </>
    )
}
export default Editsliders;